export class ClaseModel {
    documentContainerId?: string;
    documentId?: string;
    activo: boolean;
    nombre: string;
    tipo: string;
    nivel : string;
    equipo: string;
    duracion: number;
    musculos: string[];
    tags: string[];

    descripcion : string;

    imagen?: {
        nombre: string;
        url: string;
    };

    linkVideo: string;
    linksAdicionales: string[];
    propietario: string;
    empresaId: string;
}

export const tiposClases: string[] = [
    'Abdominales',
    'Aeróbics',
    'Aerobox',
    'Body Attack',
    'Body Balance',
    'Body Combat',
    'Body Pump',
    'Circuit Training',
    'Funcional',
    'GAP',
    'HIIT',
    'Meditación',
    'Otro',
    'Pilates',
    'Relajación',
    'Spinning',
    'Step',
    'Stretching',
    'Tabata',
    'Tae Bo',
    'Xcore',
    'Yoga',
    'Zumba'
  ];
  